"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var owa_options_core_1 = require("owa-options-core");
var store_1 = require("../store/store");
var owa_session_store_1 = require("owa-session-store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(legacy_1.action('saveMarkAsReadOption')(function saveMarkAsReadOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions, serviceObject;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    serviceObject = {};
                    if (optionState.behavior !== null) {
                        userOptions.PreviewMarkAsRead = optionState.behavior;
                        // This conversion is required because UserOptions deal with string literals (MarkAsRead type),
                        // whereas MailboxMessageConfigurationOptions deals with numbers (PreviewMarkAsReadBehavior const enum type)
                        switch (state.optionState.behavior) {
                            case 'Delayed':
                                serviceObject.PreviewMarkAsReadBehavior = 0 /* Delayed */;
                                break;
                            case 'OnSelectionChange':
                                serviceObject.PreviewMarkAsReadBehavior =
                                    1 /* OnSelectionChange */;
                                break;
                            case 'Never':
                                serviceObject.PreviewMarkAsReadBehavior = 2 /* Never */;
                                break;
                        }
                    }
                    if (optionState.delay !== null) {
                        userOptions.MarkAsReadDelaytime = optionState.delay;
                        serviceObject.PreviewMarkAsReadDelaytime = optionState.delay;
                    }
                    return [4 /*yield*/, owa_options_core_1.setMailboxMessageConfiguration(serviceObject)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveMarkAsReadOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-mark-as-read-option/lib/actions/saveMarkAsReadOption.js
// module id = 5042
// module chunks = 2